import { PAGE_TYPES } from '../localization/config';
import { ROUTE_CONFIG } from './constants';

class PageNameService {
	/**
	 * Get the current page name based on the current URL path
	 * @returns The page type or null if not found
	 */
	static getCurrentPageName(): keyof typeof PAGE_TYPES | null {
		const currentPath = window.location.pathname;

		const matchedRoute = Object.keys(ROUTE_CONFIG).find(route => currentPath.includes(route));

		return matchedRoute
			? (ROUTE_CONFIG[matchedRoute as keyof typeof ROUTE_CONFIG] as keyof typeof PAGE_TYPES)
			: null;
	}
}

export default PageNameService;
